var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIterableinline = function SvgIterableinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iterable_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59C1A7",
    d: "M12.475 6.525 6.77 12.341l2.874 2.93 5.704-5.816z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C3F2",
    d: "m9.6.668-2.873 2.93 5.705 5.815 2.874-2.93z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3D55",
    d: "M3.808 6.535.934 9.465l5.705 5.815 2.874-2.93z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A266D",
    d: "M6.775.53 1.07 6.344l2.874 2.93L9.65 3.458z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A266D",
    d: "M8.13 4.174c1.13 0 2.047-.934 2.047-2.087S9.26 0 8.129 0C7 0 6.082.934 6.082 2.087s.917 2.087 2.047 2.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C3F2",
    d: "M13.915 10.088c1.13 0 2.047-.934 2.047-2.087s-.917-2.087-2.047-2.087-2.048.934-2.048 2.087.917 2.087 2.048 2.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59C1A7",
    d: "M8.13 15.977c1.13 0 2.047-.935 2.047-2.087s-.917-2.087-2.048-2.087c-1.13 0-2.047.934-2.047 2.087 0 1.152.917 2.087 2.047 2.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3D55",
    d: "M4.37 8.31c.18-1.137-.577-2.21-1.693-2.394S.509 6.504.327 7.642c-.18 1.137.577 2.21 1.694 2.394S4.188 9.448 4.37 8.31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iterable_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIterableinline;